import { useEffect } from "react";
import { useSite } from "@/context/SiteContext";

export function Seo({ title, description }) {
  const { settings } = useSite();
  useEffect(() => {
    const seo = settings?.seo || {};
    const t = title || seo.site_title || "Eileen Jenkins Florist";
    const d = description || seo.meta_description || "";
    document.title = t;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", d);
    const setOg = (prop, content) => {
      let tag = document.querySelector(`meta[property="${prop}"]`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("property", prop);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    };
    setOg("og:title", t);
    setOg("og:description", d);
    if (seo.og_image) setOg("og:image", seo.og_image);
  }, [title, description, settings]);
  return null;
}
